<template>
  <div>
    <div class="box">
      <h2 class="title">{{$t('vehicles.header.title')}}</h2>

      <div v-if="vehicles.length > 0">
        <vehicle v-for="vehicle in vehicles" :key="vehicle.id" :data="vehicle" buttonType="trash" @click="deleteVehicle"></vehicle>
      </div>
      <div class="vehicles-empty" v-else>
        <p>{{$t('vehicles.empty')}}</p>
      </div>

      <button class="button is-icon is-add" @click="addVehicle()">{{$t('global.register')}}</button>
    </div>

    <zul-modal ref="addModal" :title="$t('global.registerVehicle')" :primary="$t('global.register')" @primary="saveVehicle" @secondary="back">
      <div v-if="loading">
        <p class="loading">{{$t('global.loading')}}</p> 
      </div>
      <div v-else-if="step === 1">
        <vehicle-type v-model="vehicle.type" :options="types"></vehicle-type>
        <div class="form">
          <zul-input :uppercase="true" type="text" v-model="vehicle.registrationPlate" name="plate" v-validate="{ required: true, regex: /^[a-zA-Z0-9]{3}-[a-zA-Z0-9]{4}$/ }" :mask="'XXX-XXXX'" label="Placa"></zul-input>
          <zul-input type="text" v-model="vehicle.alias" name="alias" v-validate="'required'" :label="$t('global.form.model.title')"></zul-input>
        </div>
      </div> 
      <div v-else>
        <div  class="warning">
          <h1 class="title">{{$t('vehicles.warning.title')}}</h1>
          <p>{{$t('vehicles.warning.message')}}</p>
          <span class="plate">{{ vehicle.registrationPlate }}</span>
          <p class="is-danger" v-if="error">{{ error }}</p>
        </div> 
      </div>
    </zul-modal>

    <zul-modal ref="deleteModal" primary="Remover" secondary="Cancelar" type="danger" @primary="deleteVehicle" @secondary="cancel">
      <div  class="warning">
        <h1 class="title">{{$t('vehicles.deleteWarning.title')}}</h1>
        <p>{{$t('vehicles.deleteWarning.message')}}</p>
        <span class="plate">{{ vehicle.registrationPlate }}</span>
      </div>
    </zul-modal>
  </div>
</template>

<script>
import Vehicle from '../../components/Vehicle.vue'
import VehicleType from '../../components/VehicleType.vue'

export default {
  data () {
    const vehicles = this.$auth.user().vehicles

    return {
      step: 1,
      vehicle: { type: 'CAR' },
      vehicles: vehicles || [],
      types: null,
      loading: false,
      error: null
    }
  },

  methods: {
    resetForm () {
      this.vehicle = { type: 'CAR' }
    },
    resetModal () {
      this.step = 1
      this.error = null
      this.$refs.addModal
        .setProps({
            title: this.$t('global.register2'),
            labels: { secondary: null }
          })
    },
    resetAll () {
      this.resetForm()
      this.resetModal()
    },

    addVehicle () {
      this.resetAll()
      this.loading = true

      this.$refs.addModal.setProps({labels: { primary: '' }})

      this.$http.get('/vehicle/types')
        .then(res => {
          this.types = res.data.map(o => o.vehicleType)

          this.loading = false
          this.$refs.addModal.setProps({labels: { primary: this.$t('global.register2') }})
        })

      this.$refs.addModal.open()
    },
    saveVehicle () {
      if (this.step === 1) {
        this.$validator.validateAll()
          .then(isValid => {
            if (isValid) {
              // prepare next form
              this.step++
              this.$refs.addModal
                .setProps({
                    title: '',
                    labels: { secondary: this.$t('global.fix') }
                  })
            }
          })
      } else {
        // disable button
        this.$refs.addModal.startLoading()

        this.$http.post('user/vehicle', this.vehicle)
          .then(res => {
            if (res.status === 201) {
              this.$refs.addModal.close()
              this.vehicles.push(res.data)

              this.resetAll()
            }

            // enable button
            this.$refs.addModal.stopLoading()
          }).catch(err => {
            this.error = err.response.data.message
            this.$refs.addModal.stopLoading()
          })
      }
    },
    back () {
      this.resetModal()
    },

    deleteVehicle (data) {
      if (data) {
        this.vehicle = data
        this.$refs.deleteModal.open()
      } else {
        // disable button
        this.$refs.deleteModal.startLoading()

        this.$http.delete(`user/vehicle/${this.vehicle.id}`)
          .then(res => {
            if (res.status === 200) {
              this.vehicles = this.vehicles.filter(o => o.id != this.vehicle.id)
              this.$refs.deleteModal.close()

              // enable button
              this.$refs.deleteModal.stopLoading()
            }
          }, () => {
            // enable button
            this.$refs.deleteModal.stopLoading()
          })
      }
    },    
    cancel () {
      this.resetForm()
      this.$refs.deleteModal.close()
    }
  },
  components: {
    Vehicle,
    VehicleType
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../../assets/sass/variables';

.button {
  position:  absolute;
  right: 24px;
  top: 25px;
  opacity: .5;
}

.warning {
  text-align: center;

  .title {
    font-size: $size-5;
    text-transform: uppercase;
  }
}

.dashboard .form {
  padding-top: 1.2rem;
}

.plate {
  display: inline-block;
  padding: 7px 17px 8px;
  background-color: #ccc;
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAAAECAYAAADYifLgAAAAAXNSR0IArs4c6QAAAMZJREFUOBFjZGBgYFZWVnb99++fKJBNKvj558+fI48fP35GqkZaqZeSkpJjY2OzZGRkZCPDjpf379/fwyIvLy/GwsLCy8TE9IVUQ/7//8/EysqqDNQ3aAKFk5NTGeimP8BA+UWqf4AJg19CQkKY6eHDh6+BgfIGaMg/UjFQ30+gnrukWk5j9XeYmZl/keoXqPpXL168eMcIc2BDQwPT1atX4XyYOD561apVoID8j0/NQMgBUzBjWFgYEyl2a2tr/weGwT+QHgDaBVNJWsmOzQAAAABJRU5ErkJggg==');
  background-position: center 7px;
  background-repeat: no-repeat;
  color: $black !important;
  font-size: $size-3;
  font-weight: bold;
  border-radius: 5px;
  text-transform: uppercase;
  margin: 2.5rem auto 1.5rem;
}

.vehicles-empty {
  p {
    background: $carBgIcon no-repeat center 2rem;
    text-align: center;
    padding: 5rem 0 3rem;
  }
}

.loading {
  background: url('../../assets/loading.svg') no-repeat center 35%;
  background-size: 100px;
  text-align: center;
  padding: 7rem 0 0;
  font-size: $size-7;
  opacity: .5;
  margin-right: 0;
}
</style>
